import { Component } from '@angular/core';
import { LocalizationService } from 'src/app/services/localization/localization.service';
import { Select, Store } from '@ngxs/store';
import { FormControl } from '@angular/forms';
import { LanguagesSelectors } from 'src/app/modules/reporting/store/language/language.selector';
import { Observable, take } from 'rxjs';
import { LanguageActions } from 'src/app/modules/reporting/store/language/language.actions';
import { Language } from 'src/app/modules/reporting/interfaces/language';

@Component({
  selector: 'app-languages-selector',
  templateUrl: './languages-selector.component.html',
  styleUrls: ['./languages-selector.component.scss'],
})
export class LanguagesSelectorComponent {
  @Select(LanguagesSelectors.getLanguages) languages$: Observable<Language[]>;

  languagesFormControl = new FormControl('');

  languages: Language[] = [];
  languageSelected: Language;

  constructor(
    private localizationService: LocalizationService,
    private store: Store
  ) {}

  ngOnInit(): void {
    this.setLocales();
  }

  setLocales() {
    this.store.dispatch(new LanguageActions.GetLanguages()).subscribe(() => {
      this.languages$.pipe(take(2)).subscribe((l) => {
        l.forEach((language) => {
          if (!this.languages.some((l) => l.name == language.name)) {
            this.languages.push(language);
          }
        });

        const currentLang = this.localizationService.getCurrentLang();
        this.languageSelected = this.languages.find(
          (l) => l.name.toLowerCase() === currentLang.toLowerCase()
        );
        this.languagesFormControl.setValue(this.languageSelected.name);
      });
    });
  }

  onOptionClick($event) {
    const lang = $event;
    this.languagesFormControl.setValue(lang.name);

    this.localizationService.useLanguage(lang.name.toLowerCase());
    localStorage.setItem('locale', lang.name.toLowerCase());
  }
}
